var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-icon',{ref:"svg",attrs:{"animation":_vm.animation,"flip-h":_vm.flipH,"flip-v":_vm.flipV,"font-scale":_vm.fontScale,"icon":_vm.iconObject.set == 'b' ? _vm.iconObject.value : null,"rotate":_vm.rotate,"scale":_vm.scale,"shift-h":_vm.shiftH,"shift-v":_vm.shiftV,"stacked":_vm.stacked,"title":_vm.title,"variant":_vm.variant}})
}
var staticRenderFns = []

export { render, staticRenderFns }